// removed by extract-text-webpack-plugin
module.exports = {"heading":"_1n0czC0FcM2kuQJ0wxEyDH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/Triggers.mod.css
// module id = 2130
// module chunks = 0